"use client";

import { useAuth } from "@/components/features/auth/hooks/use-auth";
import { NotificationsModal } from "@/components/notifications-modal";
import { useState } from "react";
import { AccountMenu } from "./components/account-menu";
import { DesktopNavMenu } from "./components/desktop-nav-menu";
import { MobileNavMenu } from "./components/mobile-nav-menu";
import { NavContainer } from "./components/nav-container";
import { NavLogo } from "./components/nav-logo";
import { useMainNavItems } from "./hooks/use-nav-items";

export function Nav() {
  const { isAuthenticated } = useAuth();
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const navItems = useMainNavItems();

  return (
    <>
      <NavContainer>
        <NavLogo />
        <DesktopNavMenu navItems={navItems} />
        <div className="flex items-center md:space-x-4">
          {/* Only shown on mobile */}
          <MobileNavMenu className="md:hidden" mainNavItems={navItems} />
          {/* Only shown on desktop */}
          <AccountMenu className="hidden md:block" />
        </div>
      </NavContainer>
      {isAuthenticated && (
        <NotificationsModal
          isOpen={notificationsOpen}
          onClose={() => setNotificationsOpen(false)}
        />
      )}
    </>
  );
}
